import { RackCellSchema } from "@redotech/redo-fulfillment-wms-common/schema/warehouse-cell";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const binLabelFormatSchema = createEnum([
  "individual",
  "sheet",
  "1x3",
  "1x4",
  "4x6",
]);

export const BinLabelFormat = binLabelFormatSchema.enum;
export type BinLabelFormat = z.infer<typeof binLabelFormatSchema>;

export const printBinLabels = {
  name: "printBinLabels" as const,
  input: z.object({
    racks: z.array(RackCellSchema),
    format: binLabelFormatSchema,
  }),
  output: z.object({ url: z.string() }),
};

export type PrintBinLabelsInput = z.infer<typeof printBinLabels.input>;
